import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { IFamily, IProduct } from '../_models/drilldown';

@Injectable()
export class DrilldownService {
  private _families = new BehaviorSubject<Array<IFamily>>([]);
  private _products = new BehaviorSubject<Array<IProduct>>([]);

  families = this._families.asObservable();
  products = this._products.asObservable();

  setFamilies(families: Array<IFamily>) {
    this._families.next(families);
  }

  setProducts(products: Array<IProduct>) {
    this._products.next(products);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/drilldown.service.ts